let id = 0;

export function uniqueId(): number {
    return id++;
}
